import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

import { ELkType } from '../../repositories/lk-type/entities/get_lk_type_v2/GetLkTypeResponseV2';
import { fetchGetLkType, TGetLkTypeResponse } from '../../repositories/lk-type/v2/get-lk-type';
import { UnknownError } from '@cian/peperrors';

interface IDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
}

export async function resolveLkType({ httpApi, logger }: IDependencies): Promise<ELkType | null> {
  try {
    const result: TGetLkTypeResponse = await fetchGetLkType({ httpApi });

    return result.statusCode === 200 ? result.response.lkType : null;
  } catch (error) {
    logger.error(
      new UnknownError({
        message: 'Нет информации о типе ЛК пользователя',
        domain: 'src/shared/services/lkType/service.ts',
        details: error as UnknownError,
      }),
    );

    return null;
  }
}
